import React from 'react';
import { Controller } from 'react-hook-form';
import styles from './toggleSwitch.module.scss';

interface ToggleSwitchProps {
  name: string;
  control: any;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ name, control }) => {
  return (
    <div className={styles.container}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <label className={styles.switch}>
            <input
              type="checkbox"
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            />
            <span className={styles.slider}></span>
          </label>
        )}
      />
    </div>
  );
};

export default ToggleSwitch;